const SDK_VERSION = '8.27.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
